import { ComponentProps } from "react";
import CardGroupedListItem from "@particles/card/components/CardGroupedList/CardGroupedListItem";
import { cn } from "@util/helpers";

type CardGroupedListProps = {
  /** The list of articles to display under the title */
  groupedArticles: ComponentProps<typeof CardGroupedListItem>[];
};

/**
 * Renders a list of grouped article cards.
 */
const CardGroupedList = ({
  groupedArticles,
}: CardGroupedListProps): React.ReactElement | null => {
  return (
    <div
      data-testid="card-grouped-list-component"
      className="text-left font-lct font-bold"
    >
      <p className="mb-2 mt-4 font-poppins text-4xs font-light uppercase leading-4 text-gray-515">
        Read More
      </p>

      {groupedArticles.map((article, index) => (
        <CardGroupedListItem
          {...article}
          key={article.id}
          className={cn("py-2", {
            "pb-0": index === groupedArticles.length - 1,
          })}
        />
      ))}
    </div>
  );
};

export default CardGroupedList;
